import * as QueryString from 'query-string';
import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { LoginStep } from '../components/LoginStep';
import { LandingLayout } from '../components/LandingLayout';

export const LoginPage: FC<RouteComponentProps> = ({ location }): JSX.Element => {
  const params = QueryString.parse(location.search);

  return (
    <LandingLayout>
      <LoginStep params={params} />
    </LandingLayout>
  );
};
